module.exports = "https://static-www.niulinkcloud.com/_next/static/media/icon1.948e88530a76535708b4e6331b14524c.png";